// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".favorite-icon[data-v-64ac00e5]{cursor:pointer;height:32px;transition:filter .1s ease}.favorite-icon .background[data-v-64ac00e5]{fill:#fff;stroke:#cf1619;stroke-miterlimit:10;stroke-width:2px;transition:fill .1s ease,stroke .1s ease}.favorite-icon.checked .background[data-v-64ac00e5]{fill:#cf1619}.favorite-icon[data-v-64ac00e5]:hover{filter:drop-shadow(0 0 2px rgba(207,22,25,.2))}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
